import { APP_BACKGROUND_COLOR, APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const joyrideStyles = {
  tooltip: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    font: FONT_FAMILY,
    boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.7)",
  },
  buttonNext: {
    backgroundColor: APP_COLOR,
    color: "black",
    borderRadius: "2px",
    fontSize: "16px",
    minWidth: "100px",
    margin: "0px 0px 0px 10px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  },
  buttonBack: {
    backgroundColor: "transparent",
    color: "white",
    border: "1px solid white",
    borderRadius: "2px",
    fontSize: "16px",
    font: FONT_FAMILY,
    minWidth: "100px",
    margin: "0px 10px 0px 0px",
  },
};
